/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_DealsInputs */

const en_deal_deals = /** @type {(inputs: Deal_DealsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`deals`)
};

/**
* | output |
* | --- |
* | "deals" |
*
* @param {Deal_DealsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const deal_deals = /** @type {((inputs?: Deal_DealsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_DealsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_deal_deals(inputs)
});